import { createPortal } from "react-dom";

import { PerformanceTrackingProvider } from "@features/mmm/components/performance-tracking/hooks/performance-tracking-provider";
import { PerformanceTrackingSetting } from "@features/mmm/components/performance-tracking/setting/performance-tracking-setting";
import { PerformanceTrackingTable } from "@features/mmm/components/performance-tracking/table";
import { PerformanceTrackingAtomsProvider } from "@features/mmm/components/performance-tracking/table/contexts";
import { PerformanceTrackingTargets } from "@features/mmm/components/performance-tracking/targets/performance-tracking-targets";
import { TrackingChart } from "@features/mmm/components/performance-tracking/tracking-chart/tracking-chart";
import { MINIMIZED_TOP_BAR_TAB_INFO_PORTAL_ID } from "@features/mmm/components/top-bars";
import { useAdoptedBudgetMix } from "@features/mmm/hooks/use-adopted-budget-mix";

export function PerformanceTrackingTab() {
  const { adoptedBudgetMix } = useAdoptedBudgetMix();

  return (
    <PerformanceTrackingAtomsProvider>
      <PerformanceTrackingProvider>
        <div className="mx-6 my-4 flex flex-col space-y-4">
          {adoptedBudgetMix &&
            document.getElementById(MINIMIZED_TOP_BAR_TAB_INFO_PORTAL_ID) && (
              <>
                {createPortal(
                  <div className="flex space-x-4">
                    <PerformanceTrackingSetting isMinimized />
                  </div>,
                  document.getElementById(
                    MINIMIZED_TOP_BAR_TAB_INFO_PORTAL_ID,
                  )!,
                )}
              </>
            )}
          <>
            <PerformanceTrackingTargets />
            <TrackingChart />
            <PerformanceTrackingTable />
          </>
        </div>
      </PerformanceTrackingProvider>
    </PerformanceTrackingAtomsProvider>
  );
}
